<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório estatístico de consulta">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/ambulatorio/relatorio-estatistico-consulta/List'

export default {
    components: {List},
}
</script>